import axios from './axios'
const llamarServidor=(ruta)=>(setCtl,setCargando,body)=>{
    setCargando(true);
        axios.post(ruta,body)
        .then(response=>{
          setCtl(response.data);
          setCargando(false);
        })
        .catch(error=>{
          setCtl([]);
          // console.log(error)
          setCargando(false);
        });
    }
    const llamarServidorRespuesta=(ruta)=>(respuesta,setCargando,body)=>{
      setCargando(true);
          axios.post(ruta,body)
          .then(response=>{
            setCargando(false);
            // console.log(response);
            
            if(response.status===200&&response.data.status!=undefined)
              respuesta(response.data.status,response.data.mensaje,response.data);
            else
              respuesta(-5,"ERROR DESCONOCIDO");
              
          })
          .catch(error=>{
            respuesta(-1,'Error de servidor');
            // console.log(error)
            setCargando(false);
          });
      }

const servicios = {
  // login:llamarServidorRespuesta('Login/verificar'),
  login: llamarServidorRespuesta("Login"),
  //traerRutas:llamarServidor('user/traerRutas'),
  //info:llamarServidor('user/infoUsuario'),
  loginGmail: llamarServidorRespuesta("LoginGmail"),
  validarRegistroEmailEmpresarial: llamarServidorRespuesta(
    "validar_registro_email_empresarial"
  ),
  registrarCorreoEmpresarial: llamarServidorRespuesta(
    "registrarCorreoEmpresarial"
  ),
  dominios: llamarServidorRespuesta("getDominios"),
};
export default servicios